import request from '@/utils/request'
export function getAccessToken (data) {
  return request({
    url: '/customer/token',
    method: 'post',
    data
  })
}
export function getInfo (data) {
  return request({
    url: '/customer/info',
    method: 'post',
    data
  })
}
export function register (data) {
  return request({
    url: '/customer/register',
    method: 'post',
    data
  })
}
export function login (data) {
  return request({
    url: '/customer/login',
    method: 'post',
    data
  })
}
export function logout (data) {
  return request({
    url: '/customer/logout',
    method: 'post',
    data
  })
}

export function getVerifyCode (data) {
  return request({
    url: '/sms/verify',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js